var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNearai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 208.28 208.28",
    fill: "currentColor",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28.9C0 12.94 12.94 0 28.9 0h150.48c15.96 0 28.9 12.94 28.9 28.9v150.48c0 15.96-12.94 28.9-28.9 28.9H28.9C12.94 208.28 0 195.34 0 179.38V28.9Zm143.72 24.94c-3.73 0-7.18 1.93-9.14 5.11l-21.03 31.22c-.68 1.03-.41 2.42.62 3.1.83.56 1.94.49 2.7-.17l20.7-17.95c.34-.31.87-.28 1.18.07.14.16.21.36.21.57v56.21c0 .46-.38.84-.84.84-.25 0-.48-.11-.64-.3l-62.57-74.89c-2.04-2.4-5.03-3.79-8.18-3.79h-2.19c-5.92 0-10.72 4.8-10.72 10.72v79.16c0 5.92 4.8 10.72 10.72 10.72 3.73 0 7.18-1.93 9.14-5.11l21.03-31.22c.68-1.03.41-2.42-.62-3.1-.83-.56-1.94-.49-2.7.17l-20.7 17.95c-.34.31-.87.28-1.18-.07-.14-.16-.21-.36-.21-.57V90.34c0-.46.38-.84.84-.84.25 0 .48.11.64.3l62.56 74.91c2.04 2.4 5.03 3.79 8.18 3.79h2.19c5.92 0 10.72-4.79 10.72-10.71V78.62c0-5.92-4.8-10.72-10.72-10.72Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNearai);
export default __webpack_public_path__ + "static/media/nearai.6573f4e01bb8e15214679eff8d888865.svg";
export { ForwardRef as ReactComponent };